import axios from "axios";
import {SENDBIRD_APP_API_TOKEN, SENDBIRD_APP_ID} from "utils/constants";


const inst = axios.create({
  headers: {
    "Content-Type": "application/json",
    "timezone": null,
  }
})

export const getZipCodeInfo = async (zipCode: string) => {
  const options = {
    url:"'https://us-zip-code-information.p.rapidapi.com/'",
    method: 'GET',
    params: {zipcode: zipCode},
    headers: {
      'X-RapidAPI-Key': '368289e9cdmshb4b54bfd55271b8p1be517jsn86cee0dd0c3f',
      'X-RapidAPI-Host': 'us-zip-code-information.p.rapidapi.com'
    }
  };
  try{
    const response =  await inst.request(options);
    return response.data
  }catch (e){
    return []
  }
}


export const updateSendBirdUser = async ({
                                           user_id,
                                           nickname,
                                           is_active
                                         }: {user_id: string, nickname: string, is_active: boolean}) => {

  const data = {
    nickname,
    is_active
  };

  try {
    const url = `https://api-${SENDBIRD_APP_ID}.sendbird.com/v3/users/${user_id}`;
    await inst.put(url, data, {
      headers: {
        'Api-Token': `${SENDBIRD_APP_API_TOKEN}`,
        'Content-Type': 'application/json'
      }
    });
    return true;
  }catch (e) {
    console.log(e)
    return null;
  }
}



